import React, { Component } from 'react';
import Alert from '@mui/material/Alert';

type AlertErrorProps = {
    message: string,
}

function AlertError({message}: AlertErrorProps) {
    if (message.length == 0) {
        return (<div></div>);
    }

    return (
        <Alert severity="warning">
            {message}
        <a className="alert-link" href="#">
          Example Link
        </a>
      </Alert>
    );
}

export { 
    AlertError
}